function buildFieldChange(record, changes, field) {
    const fieldSelector = `|${record.id}|${field}`;

    if (!changes[fieldSelector]) {
        return record[field];
    }

    return changes[fieldSelector].currentValue;
}

function buildCriteriaChange(recordId, criteria, changes, field) {
    const fieldSelector = `|${recordId}|${field}`;

    if (!changes[fieldSelector]) {
        return criteria[field];
    }

    return changes[fieldSelector].currentValue;
}

function buildRecipientsObjectList(recipientsList) {
    return recipientsList.map((x) => ({ address: x, recipientType: 0 }));
}

function buildRecipientChange(record, changes, field) {
    const fieldSelector = `|${record.id}|${field}`;

    if (!changes[fieldSelector]) {
        return record[field];
    }

    return buildRecipientsObjectList(changes[fieldSelector].currentValue);
}

function createSaveRequest(record, changes) {
    const criteria = Object.keys(record.criteria).reduce(
        (acc, key) => ({
            ...acc,
            [key]: buildCriteriaChange(
                record.id,
                record.criteria,
                changes,
                key
            ),
        }),
        {}
    );
    return {
        ...record,
        isActive: buildFieldChange(record, changes, 'isActive'),
        name: buildFieldChange(record, changes, 'name'),
        recipients: buildRecipientChange(record, changes, 'recipients'),
        criteria,
    };
}

export function buildChangesToSave(changes, intitialData) {
    if (Object.keys(changes).length === 0) return intitialData;

    const saveRequests = intitialData.map((x) => createSaveRequest(x, changes));
    return saveRequests;
}

function createInstanceParameters(parameters, instance) {
    const criteria = Object.keys(instance.criteria).reduce(
        (acc, key) => ({
            ...acc,
            [`${instance.id}|${key}`]: instance.criteria[key],
        }),
        {}
    );

    return {
        ...parameters,
        [`${instance.id}|isActive`]: instance.isActive,
        [`${instance.id}|name`]: instance.name,
        [`${instance.id}|recipients`]: instance.recipients.map(
            (x) => x.address
        ),
        ...criteria,
    };
}

export function buildStateFromApiCall(dataResponse = []) {
    if (!dataResponse) return {};

    return dataResponse.reduce(createInstanceParameters, {});
}
